import React, {useEffect, useMemo} from 'react';
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";

import {setMultiLoader} from "../../actions/actionFunctions";
import MultiLoaderIcons from "../common/svgIcons/multiLoaderIcons";
import store from "../../store";
import workspace from "../sqft/components/canvas/core/workspace";


const stepHeight = 68;

function getRandomArbitrary(min, max) {
  return Math.random() * (max - min) + min;
}

const getCurrentStep = () => {
  const {activeStep} = store.getState().loaderState.multiLoader;
  return activeStep
}

let timeoutId = 0;

const MultiLoaderSteps = (props) => {

  const {multiLoader, setMultiLoader, useCabinetLoader} = props;
  const {renderSteps, activeStep} = multiLoader;

  const shapesData = useMemo(() => {
    return useCabinetLoader ? workspace.getShapes() : []
  }, [useCabinetLoader]);

  const getAnimationSpeed = () => {
    let baseDuration = 1500;
    if (useCabinetLoader && Array.isArray(shapesData)) {
      baseDuration = shapesData.length * 200;
    }
    return baseDuration + getRandomArbitrary(baseDuration, baseDuration + 1000);
  }
  const animationDurations = renderSteps.map(() => getAnimationSpeed());

  // useEffect(() => {
  //   if (cabinetsGlb) {
  //     startAnimations(5);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [cabinetsGlb]);

  useEffect(() => {
    return () => {
      window.clearTimeout(timeoutId)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const startAnimations = async () => {
    for (const [stepIndex,] of renderSteps.entries()) {
      if (getCurrentStep() < stepIndex) {
        await new Promise(resolve => timeoutId = setTimeout(resolve, animationDurations[stepIndex]));
      }
      if (getCurrentStep() < stepIndex) {
        setMultiLoader({activeStep: stepIndex});
      }
    }
    timeoutId = setTimeout(() => {
      setMultiLoader({activeStep: renderSteps.length + 1});
      timeoutId = setTimeout(() => {
        setMultiLoader({finished: true});
      },  1500);
    },  getAnimationSpeed());
  }

  useEffect(() => {
    startAnimations()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const transformStyles = {
    transform: "translateY(" + -(activeStep * stepHeight) + "px)"
  }

  const finishedIterations = activeStep === (renderSteps.length + 1);

  return (
    <div className={"multi-loader__steps" + (finishedIterations ? " multi-loader__steps--finished" : "")}
         style={transformStyles}>
      {renderSteps.map((loaderStep, loaderStepIndex) => {
        const opacityDiff = 1 - (Math.abs(activeStep - loaderStepIndex) * 0.25);
        const opacity = opacityDiff === 1
          ? 1
          : opacityDiff > 0 ? opacityDiff - 0.2 : 0;

        // let animationDelay = renderSteps.reduce((total, lStep, lStepIndex) => {
        //   return lStepIndex < loaderStepIndex ? total : total + animationDurations[lStepIndex]
        // }, 0);

        return (
          <div className={"multi-loader__step flex"
            + (loaderStepIndex === activeStep ? " multi-loader__step--active" : "")
            + (loaderStepIndex > activeStep ? "" : " multi-loader__step--completed")}
               style={{opacity}}
               key={loaderStep.text}>
            <div className="multi-loader__step-icon flex">
              {MultiLoaderIcons[loaderStep.icon]}
            </div>
            <div className="multi-loader__step-content">
              <span className="multi-loader__text grohe-unc__box-title bold">
                <FormattedMessage id={"multiLoader." + loaderStep.text}/>
              </span>
              <div className="multi-loader__progressbar">
                <div className="multi-loader__progressbar-line" style={{
                  animationDuration: animationDurations + "ms"
                }}></div>
              </div>
            </div>
          </div>
        )
      })}
    </div>
  )
};

MultiLoaderSteps.propTypes = {
  useCabinetLoader: PropTypes.bool,
}

const mapStateToProps = (store) => {
  const {multiLoader} = store.loaderState;
  const {cabinetsGlb} = store.sqftState;

  return {
    multiLoader,
    cabinetsGlb,
  };
};

const mapDispatchToProps = {
  setMultiLoader,
};

export default connect(mapStateToProps, mapDispatchToProps)(MultiLoaderSteps)
